module.exports = __webpack_public_path__ + "static/media/proxxmu-hifi4.49e396fc.png";